<template>
  <v-col cols="12" sm="6" lg="6" class="mt-8 py-2">
    <v-card class="pa-2 primary4 card-radius" outlined tile v-show="canViewNotification">
      <v-card-title>
        <div class="primary1--text title ml-2">
          <v-icon size="20" style="width: 20px" class="primary1--text mb-1"> $vuetify.icon.normal-bell </v-icon>
          <span class="font-primaria font-weight-bold ml-2"> Notificações </span>
        </div>
      </v-card-title>
      <v-card-text :class="$vuetify.breakpoint.xs ? '' : 'mt-3 '">
        <div class="notification-grid d-flex flex-wrap" v-if="notificacoes.length">
          <div v-for="(n, index) in notificacoes" :key="index" class="notification-item-wrapper d-flex align-center">
            <v-avatar :color="n.tipoAlerta.cor" size="15" class="mr-2 ml-4" />
            <div class="text-start fontColor1--text caption notification-text flex-grow-1">
              <a class="notification-action" @click="$emit('redirectNotification', n)">
                <span v-if="n.mensagemCustomizada"> {{ n.mensagemCustomizada }} </span>
                <span v-if="!n.mensagemCustomizada"> {{ n.mensagemNotificacao }} </span>
              </a>
            </div>
          </div>
        </div>

        <component-loading
            style="height: 256px"
            v-if="!notificacoes.length && loadingNotificacao"
            :value="loadingNotificacao"
        />
        <v-row no-gutters align="center" v-if="!notificacoes.length && !loadingNotificacao">
          <v-col cols="12">
            <p>Nenhuma notificação encontrada.</p>
          </v-col>
        </v-row>
        <v-row
            justify="center"
            style="height: 50px"
            v-if="notificacoes.length && !loadingNotificacao && notificacoesPaginacao.qtPaginas > 1"
        >
          <v-col cols="8">
            <v-container class="max-width">
              <v-pagination
                  class="notification-pagination"
                  v-model="localPage"
                  :length="notificacoesPaginacao.qtPaginas"
                  :light="true"
                  :circle="true"
                  :color="colorPagination"
                  @input="handlePageChange"
                  :total-visible="7"
              ></v-pagination>
              <p></p>
            </v-container>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions style="padding-bottom: 18px"> </v-card-actions>
    </v-card>
  </v-col>
</template>

<script>
export default {
  name: 'NotificationCard',
  props: {
    notificacoes: { type: Array, required: true },
    notificacoesPaginacao: { type: Object, required: true },
    pageNotificacao: { type: Number, required: true },
    loadingNotificacao: { type: Boolean, default: false },
    canViewNotification: { type: Boolean, default: true },
    colorPagination: { type: String, default: '#00995d' }
  },
  data() {
    return {
      localPage: this.pageNotificacao
    }
  },
  watch: {
    pageNotificacao(newPage) {
      this.localPage = newPage
    }
  },
  methods: {
    handlePageChange(newPage) {
      this.$emit('changePage', newPage)
    }
  }
}
</script>

<style scoped>
.under {
  text-decoration: underline !important;
}

.card-radius {
  border-radius: 20px !important;
}

.notification-grid {
  min-height: 70px;
}

.notification-item-wrapper {
  flex: 0 0 50%;
  padding: 2px 6px;
  min-height: 48px;
}

.notification-text {
  white-space: normal;
  word-break: break-word;
}

@media (max-width: 960px) {
  .notification-item-wrapper {
    flex: 0 0 100%;
  }
}
</style>